import { Controller } from "@hotwired/stimulus"

// The Special Permissions add-row. Nothing clever: it clones a template so the
// page shows ONE line for the common case (nobody has any) instead of a grid
// of every ability, which is the screen this feature exists to avoid.
//
// Expiry is an explicit choice (owner ruling): picking a date unticks
// Permanent and ticking Permanent clears the date, so a row can never be saved
// with both or with neither answered by accident.
export default class extends Controller {
  static targets = ["rows", "template", "fineprint", "emptyNote"]

  add() {
    // Digits only: the controller's params permit keeps a nested-attributes
    // row only under an all-digit key and silently drops any other key,
    // which is what "new_<time>" did to every grant made from this form
    // until 2026-10-08.
    const index = `${Date.now()}${this.rowsTarget.children.length}`
    const html = this.templateTarget.innerHTML.replaceAll("NEW_INDEX", index)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    if (this.hasEmptyNoteTarget) this.emptyNoteTarget.hidden = true
    this.rowsTarget.lastElementChild.querySelector("select")?.focus()
  }

  // The fine print belongs next to the choice, not in a manual.
  describe(event) {
    const option = event.target.selectedOptions[0]
    const note = event.target.closest("div").querySelector("[data-special-permissions-target='fineprint']")
    if (note) note.textContent = option?.dataset?.finePrint || ""
  }

  permanentTicked(event) {
    if (!event.target.checked) return
    const date = event.target.closest("div").parentElement.querySelector("input[type=date]")
    if (date) date.value = ""
  }

  dateTyped(event) {
    if (!event.target.value) return
    const box = event.target.closest("div").parentElement.querySelector("input[type=checkbox]")
    if (box) box.checked = false
  }
}
